import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { ensurePublicLanguageId } from "./utility/publicLanguageStorage";

const optionsBase = {
  order: ["localStorage", "navigator"],
  caches: ["localStorage"],
  fallbackLng: ["en"],
  load: "currentOnly",
  saveMissing: true,
  saveMissingTo: "all",
  interpolation: {
    escapeValue: false,
  },
  backend: {
    loadPath: "/api/Public/translations/{{lng}}",
    addPath: "/api/Public/translations/{{lng}}",
    crossDomain: false,
  },
  nsSeparator: false,
  keySeparator: false,
  react: {
    useSuspense: false,
  },
};

/** Defaults from public appsettings via GET api/Public/languages/i18n-codes-for-instance */
async function readInstanceDefaults() {
  const fallback = {
    languageCodeForInstance: "en",
    languageCode: "en",
    instance: "MVTEO",
    defaultLanguageId: null,
  };
  try {
    const res = await fetch("/api/Public/languages/i18n-codes-for-instance");
    if (!res.ok) return fallback;
    const data = await res.json();
    const languageCodeForInstance =
      data.languageCodeForInstance ??
      data.LanguageCodeForInstance ??
      data.languageCode ??
      data.LanguageCode ??
      fallback.languageCodeForInstance;
    return {
      languageCodeForInstance,
      languageCode:
        data.languageCode ??
        data.LanguageCode ??
        languageCodeForInstance,
      instance: data.instance ?? data.Instance ?? fallback.instance,
      defaultLanguageId:
        data.defaultLanguageId ?? data.DefaultLanguageId ?? fallback.defaultLanguageId,
    };
  } catch {
    return fallback;
  }
}

/**
 * Resolve after i18n is initialised with instance default language (matches ERP i18n flow).
 * index.js should await this before calling root.render.
 */
export const i18nReady = (async () => {
  const {
    languageCodeForInstance,
    languageCode,
    instance,
    defaultLanguageId,
  } = await readInstanceDefaults();

  if (typeof localStorage !== "undefined") {
    localStorage.setItem("Instance", instance || "MVTEO");

    const storedLng = localStorage.getItem("i18nextLng");
    const storedLangId = localStorage.getItem("i18nextLanguageId");

    if (!storedLng && languageCodeForInstance) {
      localStorage.setItem("i18nextLng", languageCodeForInstance);
    }
    if (!storedLangId && defaultLanguageId) {
      localStorage.setItem("i18nextLanguageId", defaultLanguageId);
    }
  }

  const storedLng =
    typeof localStorage !== "undefined" ? localStorage.getItem("i18nextLng") : null;
  const initialLng =
    storedLng || languageCodeForInstance || languageCode || "en";

  await i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      ...optionsBase,
      lng: initialLng,
    });

  await i18n.changeLanguage(initialLng);
  await ensurePublicLanguageId(i18n.language);
  return i18n;
})();

i18n.on("languageChanged", (lng) => {
  ensurePublicLanguageId(lng);
});

export default i18n;
